import { getPhoneDisplay } from '@/lib/phone'
import { CountryFlag } from './ui/country-flag'

/**
 * Tappable phone number for detail rows: opens the dialer via tel:, shows the
 * international dial code with the matching country flag. Pass phoneCountry
 * when the dial code is stored separately (crew); omit it when the number is
 * a combined "+44 7911..." string (passengers).
 */
export function PhoneLink({
  phone,
  phoneCountry,
}: {
  phone?: string | null
  phoneCountry?: string | null
}) {
  const parsed = getPhoneDisplay(phone, phoneCountry)
  if (!parsed) return <span>-</span>

  return (
    <a href={parsed.telHref} className="text-content-brand-bold text-right">
      {parsed.iso2 && <CountryFlag iso2={parsed.iso2} className="w-4 mr-1.5 align-[-2px]" />}
      {parsed.display}
    </a>
  )
}

/** Tappable email address for detail rows: opens the mail app via mailto:. */
export function EmailLink({ email }: { email?: string | null }) {
  if (!email) return <span>-</span>

  return (
    <a href={`mailto:${email}`} className="text-content-brand-bold text-right break-all">
      {email}
    </a>
  )
}
